import apiClient from './apiClient'


const getNotification = (tenant, projectId, onlyThisProject) => {
  const params = {
    onlyThisProject
  }
  return apiClient.get(`/${tenant}/Notification/${projectId}`, { params })
}


export default {
  getNotification
}
